class SearchBar extends HTMLElement {
    constructor() {
        super()
        this.btnsOpen = this.querySelectorAll('[data-modal-open]')
        this.btnsClose = this.querySelectorAll('[data-modal-close]')
        this.modal = this.querySelector(".search-bar-modal")
        this.searchInput = this.querySelector("#searchInput")
        this.containerResults = this.querySelector(".results-container .predictive-search")
        this.init()
    }
  
    init() {
        this.searchInput.addEventListener('input', this.debounce((event) => {
            this.onChange(event)
        }, 300).bind(this))
        this.btnsOpen.forEach((btn) => btn.addEventListener('click', () => this.modal.setAttribute("show", "")))
        this.btnsClose.forEach((btn) => btn.addEventListener('click', () => this.modal.removeAttribute("show", "")))
    }
  
    debounce(func, delay) {
        let timerId
        return function (...args) {
            clearTimeout(timerId)
            timerId = setTimeout(() => {
                func.apply(this, args)
            }, delay)
        }
    }
  
    onChange(event) {
        const searchTerm = this.searchInput.value.trim()
        this.getSuggestions(searchTerm)
        return
    }
  
    async getSuggestions(searchTerm) {
        const url = `search/suggest?q=${encodeURIComponent(searchTerm)}&resources[type]=query,product&resources[limit]=6&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title&section_id=predictive-search-section`
        const fetchResponse = await fetch(url)
        const responseText = await fetchResponse.text()
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const selectors = ["#predictive-search-results"];
        
        for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
            }
        }
    }
}

customElements.define('search-bar', SearchBar)